import axios from "src/utils/axios";
import { setUserSuccess } from "src/redux/slices/authJwt";
import { openKiosk } from "src/redux/slices/employee";
import { inactivityLockSeconds } from "src/utils/inactivityLock";

// 2026-10-18 · Antes de bloquear por inactividad se relee el ajuste del
// servidor. La tablet guarda una copia del usuario (ajustes incluidos) que
// solo se refresca al arrancar: si el dueño desactivaba el bloqueo desde
// otro dispositivo (el PC de la oficina), la tablet seguía bloqueándose con
// el valor viejo hasta recargar. Si la relectura falla (sin red), se decide
// con la copia local, como antes.
let inFlight = null;

export function lockOnInactivityIfEnabled() {
  return (dispatch, getState) => {
    if (inFlight) return inFlight;
    inFlight = (async () => {
      let user = getState()?.authJwt?.user;
      try {
        const userId = window.localStorage.getItem("userId");
        if (userId) {
          const res = await axios.get(`authentication/user/${userId}`);
          if (res?.data?.user) {
            user = res.data.user;
            dispatch(setUserSuccess(user));
          }
        }
      } catch { /* sin red: copia local */ }

      const employees = getState()?.employees || {};
      if (employees.kioskOpen) return false;
      if (!employees.currentActiveEmployee) return false;
      if (inactivityLockSeconds(user) === null) return false;
      dispatch(openKiosk({ manual: false }));
      return true;
    })();
    return inFlight.finally(() => { inFlight = null; });
  };
}
